__turbopack_context__.v({
  "button": "accordion-module-scss-module__f2QgoG__button",
  "content": "accordion-module-scss-module__f2QgoG__content",
  "content-wrapper": "accordion-module-scss-module__f2QgoG__content-wrapper",
  "details": "accordion-module-scss-module__f2QgoG__details",
  "disabled": "accordion-module-scss-module__f2QgoG__disabled",
  "header-content": "accordion-module-scss-module__f2QgoG__header-content",
  "icon": "accordion-module-scss-module__f2QgoG__icon",
  "long": "accordion-module-scss-module__f2QgoG__long",
  "no-overflow": "accordion-module-scss-module__f2QgoG__no-overflow",
  "outline": "accordion-module-scss-module__f2QgoG__outline",
  "short": "accordion-module-scss-module__f2QgoG__short",
  "subtitle": "accordion-module-scss-module__f2QgoG__subtitle",
  "summery": "accordion-module-scss-module__f2QgoG__summery",
  "title": "accordion-module-scss-module__f2QgoG__title",
  "underline": "accordion-module-scss-module__f2QgoG__underline",
});
